import React from "react";

const Java_Variables = () => {
  return (
    <div>
      <h1>Java Variables</h1>
      <p>This page provides explanations, examples, and common use-cases for Java Variables in Java.</p>
    </div>
  );
};

export default Java_Variables;
